import {
	action,
	computed,
	makeObservable,
	observable,
	runInAction,
	when,
} from 'mobx';
import { localStorageHandlers } from 'utils/localStorageHandlers/localStorageHandlers';

interface Data {
	authId?: string;
	authAccessTokenLifetime?: number;
	authRefreshTokenLifetime?: number;
	lastAuthTimestamp?: number;
	activeTab?: string;
}

export class AppDataStore {
	@observable
	private data: Data;

	@observable
	private isInitData: boolean;
	constructor() {
		this.isInitData = false;
		this.data = this.getData();
		makeObservable(this);
	}
	@computed
	public get isInit() {
		return this.isInitData;
	}
	@computed
	public get authId() {
		return this.data?.authId || '';
	}

	@computed
	public get lastAuthTimestamp() {
		return this.data.lastAuthTimestamp || 0;
	}
	@computed
	public get authAccessTokenLifetime() {
		return this.data.authAccessTokenLifetime || 0;
	}
	@computed
	public get authRefreshTokenLifetime() {
		return this.data.authRefreshTokenLifetime || 0;
	}

	@action.bound
	public setLastAuthTimestamp(lastAuthTimestamp?: number) {
		this.setData({
			...this.data,
			lastAuthTimestamp,
		});
	}
	@action.bound
	public setAuthId(authId?: string) {
		this.setData({
			...this.data,
			authId,
		});
	}
	@action.bound
	public setAuthAccessTokenLifetime(authAccessTokenLifetime?: number) {
		this.setData({
			...this.data,
			authAccessTokenLifetime,
		});
	}
	@action.bound
	public setAuthRefreshTokenLifetime(authRefreshTokenLifetime?: number) {
		this.setData({
			...this.data,
			authRefreshTokenLifetime,
		});
	}

	@action.bound
	public setActiveTab(activeTab?: string) {
		this.setData({
			...this.data,
			activeTab,
		});
	}
	@action.bound
	public async init() {
		await when(() => !!this.data);
		runInAction(() => {
			this.isInitData = true;
		});
	}

	@action.bound
	private setData(appData: Data) {
		this.data = appData;
		localStorageHandlers.app.setAppData(JSON.stringify(appData));
	}
	@action.bound
	private getData() {
		return JSON.parse(localStorageHandlers.app.getAppData());
	}
}
export const appDataStore = new AppDataStore();
